import { jsxs, jsx } from 'react/jsx-runtime';
import ContentLoader from 'react-content-loader';

function ChartLoader(props) {
  return jsxs(ContentLoader, {
    viewBox: "0 0 200 200",
    height: 300,
    className: "w-full",
    ...props,
    children: [jsx("rect", {
      x: "0",
      y: "160",
      rx: "0",
      ry: "0",
      width: "25",
      height: "40"
    }), jsx("rect", {
      x: "30",
      y: "145",
      rx: "0",
      ry: "0",
      width: "25",
      height: "55"
    }), jsx("rect", {
      x: "60",
      y: "126",
      rx: "0",
      ry: "0",
      width: "25",
      height: "74"
    }), jsx("rect", {
      x: "90",
      y: "80",
      rx: "0",
      ry: "0",
      width: "25",
      height: "120"
    }), jsx("rect", {
      x: "120",
      y: "142",
      rx: "0",
      ry: "0",
      width: "25",
      height: "58"
    })]
  });
}

export { ChartLoader };
